<template>
    <TransitionRoot appear
                    :show="isOpen"
                    as="template">
        <Dialog :open="isOpen"
                class="overflow-y-auto fixed inset-y-0 left-0 z-dialog w-screen"
                @close="closeModal">
            <div class="flex justify-center items-center min-h-screen">
                <TransitionChild as="template"
                                 enter="duration-200 ease-out"
                                 enter-from="opacity-0"
                                 enter-to="opacity-100"
                                 leave="duration-200 ease-in"
                                 leave-from="opacity-100"
                                 leave-to="opacity-0">
                    <DialogOverlay class="fixed inset-y-0 left-0 w-screen bg-black/60"/>
                </TransitionChild>

                <TransitionChild as="template"
                                 enter="duration-200 ease-out transform"
                                 enter-from="opacity-0 scale-50"
                                 enter-to="opacity-100 scale-100"
                                 leave="duration-200 ease-in transform"
                                 leave-from="opacity-100 scale-100"
                                 leave-to="opacity-0 scale-50">
                    <div class="content-wrap editor-styles">
                        <button type="button"
                                :aria-label="$translate('Accessibility.CloseDialog')"
                                class="absolute top-0 right-0 mr-40 bg-white rounded-full transition-transform hover:rotate-180 md:mt-15"
                                @click="closeModal()">
                            <CIcon name="close-content"
                                   color="black"
                                   class="w-70 h-auto"
                                   :fill="false"/>
                        </button>

                        <div class="inner-content">
                            <DialogTitle v-if="title"
                                         as="h4">
                                {{ title }}
                            </DialogTitle>
                            <DialogDescription v-if="description"
                                               class="text-16"
                                               v-html="description"/>
                            <div v-if="title || description"
                                 class="mb-20"></div>
                            <slot :close="closeModal"/>
                        </div>
                        <div class="absolute inset-0 -z-1">
                            <svg width="100%"
                                 height="100%"
                                 viewBox="0 0 301 236"
                                 preserveAspectRatio="none"
                                 version="1.1"
                                 xmlns="http://www.w3.org/2000/svg"
                                 xmlns:xlink="http://www.w3.org/1999/xlink">
                                <defs>
                                    <path id="path-base-dialog1"
                                          vector-effect="non-scaling-stroke"
                                          d="M816.887606,2905.10649 C825.611405,2897.9162 831.296247,2895.18926 838.11967,2893.51201 C844.943092,2891.83476 854.879653,2891.71757 860.906679,2889.14573 C866.933706,2886.57389 876.160914,2884.77918 882.900708,2884.77918 C889.640502,2884.77918 907.884205,2884.77918 915.260717,2884.77918 C922.63723,2884.77918 933.903327,2887.51553 940.494817,2887.51553 C947.086306,2887.51553 973.144235,2884.77918 980.044006,2884.77918 C986.943777,2884.77918 1019.01637,2882 1024.61636,2882 C1030.21635,2882 1052.72539,2883.14924 1062.11857,2889.14573 C1071.51174,2895.14221 1077.8626,2898.89087 1080.54304,2909.25191 C1083.22347,2919.61295 1083.22347,2927.2307 1083.22347,2930.81625 C1083.22347,2934.40181 1085.89407,2939.05364 1085.89407,2945.80363 C1085.89407,2952.55361 1083.22347,2962.66075 1083.22347,2972.69636 C1083.22347,2982.73197 1080.54304,2997.28903 1080.54304,3002.41038 C1080.54304,3007.53174 1078.69893,3017.60338 1078.69893,3022.79237 C1078.69893,3027.98137 1077.00597,3038.31571 1067.31578,3045.45943 C1057.62558,3052.60314 1045.99588,3061.35175 1037.23384,3061.35175 C1028.4718,3061.35175 1015.11699,3064.05031 1011.06164,3064.05031 C1007.0063,3064.05031 999.00563,3066.74887 989.524818,3064.05031 C980.044006,3061.35175 958.878084,3064.05031 954.404765,3064.05031 C949.931446,3064.05031 940.485662,3066.74887 921.579384,3064.05031 C902.673107,3061.35175 892.259392,3061.35175 888.957062,3061.35175 C886.755509,3061.35175 882.281595,3061.35175 875.535322,3061.35175 C874.416883,3061.13011 873.243879,3062.02963 872.016312,3064.05031 C870.174961,3067.08132 867.826509,3079.77926 865.217357,3083.10409 C862.608205,3086.42891 859.186052,3091.35439 855.742115,3094.61586 C852.298177,3097.87732 844.63995,3103.53381 844.63995,3103.53381 C844.63995,3103.53381 836.487287,3112.00258 844.63995,3097.55333 C852.792613,3083.10409 853.180772,3077.00519 853.180772,3072.74113 C853.180772,3068.47706 857.09192,3061.35175 848.823655,3061.35175 C840.555391,3061.35175 829.416755,3058.18825 825.147371,3057.39707 C820.877986,3056.60589 815.919018,3051.15597 812.475081,3048.3077 C809.031143,3045.45943 799.94588,3032.3655 799.94588,3026.35722 C799.94588,3020.34894 799.94588,3001.64844 799.94588,2996.16942 C799.94588,2990.6904 797.906425,2979.61135 797.906425,2972.69636 C797.906425,2965.78137 795.866969,2951.23538 797.906425,2944.08169 C799.94588,2936.92799 799.912181,2927.2871 802.40939,2922.94498 C804.906599,2918.60285 808.163807,2912.29678 816.887606,2905.10649 Z"/>
                                </defs>
                                <g id="Styleguide"
                                   stroke="none"
                                   stroke-width="1"
                                   fill="none"
                                   fill-rule="evenodd">
                                    <g id="lagerbesked"
                                       transform="translate(-791.000000, -2876.000000)">
                                        <use stroke="#FFFFFF"
                                             stroke-width="13"
                                             fill="#FFFFFF"
                                             fill-rule="evenodd"
                                             xlink:href="#path-base-dialog1"/>
                                        <use stroke="#000000"
                                             stroke-width="8"
                                             xlink:href="#path-base-dialog1"/>
                                    </g>
                                </g>
                            </svg>
                        </div>
                    </div>
                </TransitionChild>
            </div>
        </Dialog>
    </TransitionRoot>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue';
import { Dialog, DialogDescription, DialogOverlay, DialogTitle, TransitionRoot, TransitionChild } from '@headlessui/vue';
import bus from '@/core/bus';
import { DialogClosedKey } from '@/project/dialog/dialog';

export default defineComponent({
    name: 'BaseDialog',
    components: { Dialog, DialogOverlay, DialogTitle, DialogDescription, TransitionRoot, TransitionChild },
    props: {
        title: {
            type: String,
            default: '',
        },
        description: {
            type: String,
            default: '',
        },
        provideResult: {
            type: Function,
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            default: () => {},
            required: false,
        },
    },
    setup(props) {
        const isOpen = ref(true);

        return {
            isOpen,
            closeModal() {
                isOpen.value = false;
                if (props.provideResult) {
                    const result = props.provideResult();
                    bus.emit(DialogClosedKey, result);
                }
            },
        };
    },
});
</script>

<style scoped>
    .content-wrap {
        width: 100%;
        margin-left: 2rem;
        margin-right: 2rem;
        max-width: 100%;
        height: 65rem;
        max-height: 100vh;
        @apply mx-auto z-1 relative;
    }
    .inner-content {
        margin-top: 10rem;
        max-width: calc(100% - 15rem);
        max-height: calc(100% - 32.5rem);
        overflow: auto;
        @apply mx-auto relative;

        &:after {
            content: '';
            height: 10rem;
            width: 100%;
            background: linear-gradient(rgba(255,255,255,0), rgba(255,255,255,1)) left repeat;
            bottom: 0;
            @apply block sticky;
        }
    }

    @screen md {
        .content-wrap {
            width: 98rem;
            height: 76.5rem;
        }
        .inner-content {
            margin-top: 8rem;
            max-width: 60rem;
        }
    }

    @screen lg {
        .inner-content {
            max-width: 66rem;
            @apply pr-15;
        }
    }
</style>

<style>
    .inner-content a {
        @apply text-pink-100 hover:underline hover:text-pink-200;
    }
</style>
